/* eslint-disable graphql/template-strings */
import { gql } from '@apollo/client';

export const MARK_NOTIFICATIONS_READ = gql`
  mutation MarkNotificationsRead($input: MarkNotificationsReadInput!) {
    markNotificationsRead(input: $input)
  }
`;

export const MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation MarkAllNotificationsRead {
    markAllNotificationsRead
  }
`;

export const REMOVE_NOTIFICATIONS = gql`
  mutation RemoveNotifications($input: RemoveNotificationsInput!) {
    removeNotifications(input: $input)
  }
`;

export const REMOVE_ALL_NOTIFICATIONS = gql`
  mutation RemoveAllNotifications {
    removeAllNotifications
  }
`;

export const UPSERT_DEVICE_FCM_TOKEN = gql`
  mutation UpsertDeviceFcmToken($input: UpsertDeviceFcmTokenInput!) {
    upsertDeviceFcmToken(input: $input)
  }
`;
